const PENDO_TRIAL_ENROLL_MODAL_GUIDE_ID = '3sUXVkgt-Nlctg9qdaUfurG7EhQ';
const PENDO_UPGRADE_MODAL_GUIDE_ID = '8jhoXRCuNf9_3bm75KocIr0133c';
export const PENDO_BASE_ID = 'pendo-base';
export const PENDO_UPGRADE_CTA_QUERY_SELECTOR = '[aria-label^=ccaas-upgrade]';
export const PENDO_START_TRIAL_CTA_QUERY_SELECTOR = '[aria-label^=ccaas-start-free-trial]';
export const PENDO_CLOSE_TRIAL_GUIDE_SELECTOR = '[aria-label^=free-trial-guide-dismiss]';
export const PENDO_CLOSE_UPGRADE_GUIDE_SELECTOR = '[aria-label^=upgrade-guide-dismiss]';
export const PENDO_CONCLUDE_UPGRADE_GUIDE_SELECTOR = '[aria-label^=upgrade-guide-conclude]';
export const showPendoUpgradeModal = () => {
    var _a;
    (_a = window['pendo']) === null || _a === void 0 ? void 0 : _a.showGuideById(PENDO_UPGRADE_MODAL_GUIDE_ID);
};
export const showPendoTrialEnrollModal = () => {
    var _a;
    (_a = window['pendo']) === null || _a === void 0 ? void 0 : _a.showGuideById(PENDO_TRIAL_ENROLL_MODAL_GUIDE_ID);
};
//# sourceMappingURL=pendo.js.map